export const vCutValue = {
  mounted: (el, binding) => {
    const length = binding.value
    const content = el.textContent

    el.textContent = content.length > length ? content.slice(0, length) + '...' : content
  }
}